// Razorpay Configuration
// Note: Only the key_id should be in frontend code. key_secret should NEVER be exposed to the frontend.

export const RAZORPAY_CONFIG = {
  // Public key - safe to expose in frontend
  key_id: "rzp_live_5oaYzT7Oi3FDSG",

  // Default payment options
  currency: "INR",
  company_name: "Official Vishwateja",
  company_logo: "https://your-domain.com/favicon.svg", // Use absolute HTTPS URL or leave empty
  theme_color: "#3B82F6",

  // Common payment amounts (in paise - Razorpay uses smallest currency unit)
  AMOUNTS: {
    MBBS_SEAT_BOOKING: 2000000, // ₹20,000 in paise
    CONSULTATION_FEE: 50000, // ₹500 in paise
    APPLICATION_FEE: 100000, // ₹1,000 in paise
  },
};

// Environment-specific configurations
export const getEnvironmentConfig = () => {
  const isProduction = process.env.NODE_ENV === "production";

  return {
    isProduction,
    // In production, you might want to use different keys or settings
    key_id: isProduction ? RAZORPAY_CONFIG.key_id : RAZORPAY_CONFIG.key_id,
    // For development, we might want to use test mode
    testMode: !isProduction,
  };
};

// Helper function to format amount for display
export const formatAmount = (amountInPaise) => {
  return `₹${(amountInPaise / 100).toLocaleString("en-IN")}`;
};

// Common prefill data structure
export const getDefaultPrefill = (userInfo = {}) => ({
  name: userInfo.name || "",
  email: userInfo.email || "",
  contact: userInfo.phone || "",
});

// Payment success/failure URLs (update these according to your routes)
export const CALLBACK_URLS = {
  success: "/payment-success",
  failure: "/payment-failure",
  cancel: "/payment-cancelled",
};
